import { Flex, Box, DataList, Button, Text } from "@radix-ui/themes";
import toast from "react-hot-toast";
import { useCopyToClipboard } from "react-use";

type LineItemProps = {
  line?: {
    quantity: number;
    sku_base_id: number;
    name: string;
    barcode: string;
    variant_id: string;
    uom: string;
    image_url: string;
  };
  isQuantityDifferent?: boolean;
};

export function LineItem({ line, isQuantityDifferent }: LineItemProps) {
  const [_, copyToClipboard] = useCopyToClipboard();

  const handleCopyValue = (label: string, value: string) => () => {
    copyToClipboard(value);
    toast.success(`${label} copied to clipboard`);
  };

  if (!line)
    return (
      <Flex justify="center" align="center" className="h-20">
        <Text size="1" color="gray">
          No matching data
        </Text>
      </Flex>
    );

  return (
    <Flex gap="2">
      <Box mr="2" ml="1">
        <img
          key={line.image_url}
          src={line.image_url}
          className="min-w-20 w-20 h-20 object-contain"
          width={80}
          height={80}
        />
      </Box>
      <Box className="w-full pr-2 relative">
        <Button
          variant="ghost"
          color="gray"
          highContrast
          size="1"
          className="text-left"
          mb="2"
          onClick={handleCopyValue("Product variant name", line.name)}
        >
          <Text size="1" weight="medium">
            {line.name}
          </Text>
        </Button>

        <DataList.Root size="1" className="gap-0.5">
          <DataList.Item>
            <DataList.Label>Barcode</DataList.Label>
            <DataList.Value>
              <Button
                variant="ghost"
                color="gray"
                highContrast
                size="1"
                className="py-0.5 px-1 -mx-1 -my-0.5"
                onClick={handleCopyValue("Barcode", line.barcode)}
              >
                {line.barcode}
              </Button>
            </DataList.Value>
          </DataList.Item>
          <DataList.Item>
            <DataList.Label>SKU ID</DataList.Label>
            <DataList.Value>
              <Button
                variant="ghost"
                color="gray"
                highContrast
                size="1"
                className="py-0.5 px-1 -mx-1 -my-0.5"
                onClick={handleCopyValue("SKU ID", line.sku_base_id.toString())}
              >
                {line.sku_base_id}
              </Button>
            </DataList.Value>
          </DataList.Item>
          <DataList.Item
            className={isQuantityDifferent ? "bg-[var(--red-3)]" : ""}
          >
            <DataList.Label>Quantity</DataList.Label>
            <DataList.Value>
              <Button
                variant="ghost"
                color="gray"
                highContrast
                size="1"
                className="py-0.5 px-1 -mx-1 -my-0.5"
                onClick={handleCopyValue("Quantity", line.quantity.toString())}
              >
                {line.quantity} {line.uom}
              </Button>
            </DataList.Value>
          </DataList.Item>
        </DataList.Root>
      </Box>
    </Flex>
  );
}
